import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslationService } from '../../../services/translation/translation.service';

interface Language {
  code: string;
  name: string;
  flag: string;
}

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent implements OnInit, OnDestroy {
  currentLanguage: string = 'en';
  
  languages: Language[] = [];

  private _unsubscribeAll: Subject<any>;

  constructor(
    private translateService: TranslateService,
    private translationService: TranslationService
  ) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    // Get supported languages from the translation service
    const supportedLanguages = this.translationService.getSupportedLanguages();
    this.languages = supportedLanguages.map(code => ({
      code,
      name: this.translationService.getLanguageDisplayName(code),
      flag: this.translationService.getLanguageFlag(code)
    }));
        
    // Get current language from our custom translation service
    this.currentLanguage = this.translationService.getCurrentLanguage();
    
    // Subscribe to language changes from our custom translation service
    this.translationService.currentLanguage$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((language) => {
        this.currentLanguage = language;
      });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  changeLanguage(languageCode: string): void {
    
    // Use our custom translation service to change the language
    // This will handle all the logic including storing preferences and updating the TranslateService
    this.translationService.setLanguage(languageCode);
    
  }

  getCurrentLanguageName(): string {
    return this.translationService.getLanguageDisplayName(this.currentLanguage);
  }

  getCurrentLanguageFlag(): string {
    return this.translationService.getLanguageFlag(this.currentLanguage);
  }
}
